import { Transition } from '@headlessui/react'
import classNames from 'classnames'
import { Fragment, useEffect, useRef } from 'react'
import useModalBackButton from '../../../../modules/hooks/common/useModalBackButton'
import usePopupStore from '../../../../store/usePopupStore'

export interface SidePopupPayload {
  id: string
  body: any
  title?: any
  onClose?: any
  overlayClose?: boolean
  noTopSide?: boolean //and X button disappear too.
  hFull?: boolean
  bgWhite?: boolean
  border?: boolean
  maxW?: number
  bgColor?: string
  noScrollbar?: boolean
}

export const useCafSidePopup = () => {
  const popupShow = usePopupStore((state) => state.show)
  const popupClose = usePopupStore((state) => state.close)

  const show = (props: SidePopupPayload) => {
    popupShow({ ...props, type: 'cafSide' })
  }
  const close = (id) => {
    popupClose({ id })
  }
  return { show, close }
}

export const CafSidePopup = ({ id }) => {
  const focusRef = useRef(null)
  const popupClose = usePopupStore((state) => state.close)
  const { data, isShow } = usePopupStore((state) => ({
    data: state.data[id],
    isShow: state.isPopupRendered,
  }))
  const open = data ? true : false
  const {
    title = '',
    body = undefined,
    onClose = null,
    maxW = 375,
    overlayClose = true,
    noTopSide = false,
    hFull = false,
    bgWhite = false,
    border = false,
    bgColor = 'white',
    noScrollbar = true,
  } = data ? data : {}

  useModalBackButton(id, isShow)

  useEffect(() => {
    return () => {
      popupClose({ id })
    }
  }, [])

  return (
    <div id={id}>
      <Transition appear show={open} as={Fragment}>
        <div ref={focusRef} className="min-w-[448px]">
          <button ref={focusRef} className="hidden" />
          {/* This element is to trick the browser into centering the modal contents. */}
          {/* <span aria-hidden="true" className="hidden sm:align-middle">
          &#8203;
        </span> */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-x-20 sm:translate-y-0"
            enterTo="opacity-100 translate-x-0"
          >
            <div
              className="z-9999 fixed right-0 bottom-0 min-w-[448px] transform overflow-hidden drop-shadow-[0px_2px_8px_rgba(0,0,0,0.15)] transition-all"
              style={{ maxWidth: maxW }}
            >
              <div
                style={{ height: hFull ? 'calc(100vh - 70px)' : '80vh' }}
                className={classNames(
                  { 'border-1': border },
                  { 'no-scrollbar': noScrollbar },
                  'flex flex-col overflow-y-auto bg-white shadow-lg'
                )}
              >
                {/* BODY */}
                <div style={{ backgroundColor: bgColor || 'white', height: '100%' }}>{body}</div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Transition>
    </div>
  )
}
